<template>
  <div class="wf-page">
    <div class="wf-page-head">
      <el-input v-model="query.condition.keyword" size="small" placeholder="搜索标题/发起人" style="width: 220px"
                clearable @keyup.enter.native="reload" />
      <el-select v-if="type === 'ccMe'" v-model="query.condition.readStatus" size="small" placeholder="阅读状态"
                 style="width: 120px" clearable>
        <el-option label="未读" :value="0" />
        <el-option label="已读" :value="1" />
      </el-select>
      <el-select v-if="type === 'myApply'" v-model="query.condition.status" size="small" placeholder="状态"
                 style="width: 120px" clearable>
        <el-option label="审批中" :value="0" />
        <el-option label="已通过" :value="1" />
        <el-option label="已拒绝" :value="2" />
        <el-option label="已撤销" :value="3" />
      </el-select>
      <el-button size="small" icon="el-icon-search" @click="reload">查询</el-button>
    </div>

    <el-table :data="list" v-loading="loading" size="small" border style="width: 100%">
      <el-table-column prop="title" label="标题" min-width="200" show-overflow-tooltip />
      <el-table-column v-if="type === 'myApply'" prop="flowName" label="流程" min-width="120" />
      <el-table-column v-else prop="initiatorName" label="发起人" width="100" />
      <el-table-column v-if="type !== 'myApply'" prop="nodeName" label="当前/处理节点" min-width="120" />
      <el-table-column v-if="type === 'myApply'" label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="instStatusType(row.status)">{{ instStatusText(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="type === 'done'" label="我的处理" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.status === 1 ? 'success' : 'danger'">{{ row.status === 1 ? '同意' : '拒绝' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="type === 'ccMe'" label="阅读" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.status === 3 ? 'info' : 'warning'">{{ row.status === 3 ? '已读' : '未读' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="type === 'todo' || type === 'ccMe' || type === 'myApply'" prop="createTime" label="时间" width="160" />
      <el-table-column v-if="type === 'done'" prop="handleTime" label="处理时间" width="160" />
      <el-table-column label="操作" :width="type === 'myApply' ? 150 : 120" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="openDetail(row)">{{ type === 'todo' ? '审批' : '查看' }}</el-button>
          <el-button v-if="type === 'ccMe' && row.status !== 3" type="text" size="mini" @click="markRead(row)">标记已读</el-button>
          <el-button v-if="type === 'myApply' && row.status === 0" type="text" size="mini" style="color:#E6A23C" @click="doRevoke(row)">撤销</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="wf-pager" background layout="total, prev, pager, next"
                   :total="total" :current-page="query.page" :page-size="query.limit" @current-change="onPage" />

    <el-dialog title="审批详情" :visible.sync="detailVisible" width="820px" top="6vh" append-to-body
               :close-on-click-modal="false">
      <WflowDetail v-if="detailVisible" :instance-id="currentInstanceId" @refresh="onDetailRefresh" />
    </el-dialog>
  </div>
</template>

<script>
import WflowDetail from '../WflowDetail.vue'
import { todo, done, ccMe, myApply } from '@/api/wflow/task'
import { ccRead, revoke } from '@/api/wflow/process'

const API = { todo, done, ccMe, myApply }

export default {
  name: 'TaskListView',
  components: { WflowDetail },
  props: {
    type: { type: String, required: true } // todo | done | ccMe | myApply
  },
  data() {
    return {
      loading: false, list: [], total: 0,
      query: { page: 1, limit: 10, condition: { keyword: '', readStatus: null, status: null } },
      detailVisible: false, currentInstanceId: null
    }
  },
  created() {
    this.reload()
  },
  methods: {
    reload() { this.query.page = 1; this.load() },
    load() {
      const api = API[this.type]
      if (!api) return
      this.loading = true
      api(this.query).then(res => {
        this.loading = false
        if (res && res.code === 200 && res.data) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        }
      }).catch(() => { this.loading = false })
    },
    onPage(p) { this.query.page = p; this.load() },
    instanceIdOf(row) { return this.type === 'myApply' ? row.id : row.instanceId },
    openDetail(row) {
      this.currentInstanceId = this.instanceIdOf(row)
      this.detailVisible = true
    },
    onDetailRefresh() { this.load() },
    markRead(row) {
      ccRead(row.taskId).then(res => { if (res && res.code === 200) { this.$message.success('已标记已读'); this.load() } })
    },
    doRevoke(row) {
      this.$confirm('确认撤销该申请？', '提示', { type: 'warning' })
        .then(() => revoke(row.id))
        .then(res => { if (res && res.code === 200) { this.$message.success('已撤销'); this.load() } })
        .catch(() => {})
    },
    instStatusText(s) { return { 0: '审批中', 1: '已通过', 2: '已拒绝', 3: '已撤销' }[s] || '—' },
    instStatusType(s) { return { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' }[s] || 'info' }
  }
}
</script>

<style scoped>
.wf-page { padding: 4px; }
.wf-page-head { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.wf-pager { margin-top: 12px; text-align: right; }
</style>
